module.exports = __webpack_public_path__ + "img/reset-password-v2.d3af8490.svg";